$(function(){
  // animation delay ------------------------------
  if (window.matchMedia('(min-width: 700px)').matches) {
    $('.delayWrap').each(function(){
      $(this).children('.delay').each(function(i){
        var delay = 0.1 * i;
        $(this).css('animation-delay', delay + 's');
      });
    });
  }

  // accordion
  $('.og-accordion-wrap .accordion__toggle').on('click', function(){
    $(this).toggleClass('open');
    $(this).next('.accordion__content').slideToggle('slow');
  });
  $('.og-accordion-wrap .og-accordion-close').on('click', function(){
    $(this).parent('.accordion__content').prev('.accordion__toggle').toggleClass('open');
    $(this).parent('.accordion__content').slideToggle('slow');
  });
});



// scroll anime ------------------------------
$(window).on('load',function(){
  $('.og-anime').each(function(){
    var elemTop = $(this).offset().top;
    var windowHeight = elemTop - $(window).height();
    if ($(window).scrollTop() > windowHeight){
      if(!$(this).hasClass('active')) {
        $(this).addClass('active');
      };
    };
  });
  $(window).scroll(function(){ 
    var scroll = $(window).scrollTop();
    $('.og-anime').each(function(){
      var elemTop = $(this).offset().top;
      var windowHeight = $(window).height();
      if (scroll + windowHeight > elemTop){
        if(!$(this).hasClass('active')) {
          $(this).addClass('active');
        };
      };
    });
  });

  setTimeout(function(){
    $('.wishlist-hero-list-card').each(function(){
      var text = $(this).find('.MuiCardHeader-root');
      var img = $(this).find('.MuiTypography-root.MuiLink-root.MuiLink-underlineHover.MuiTypography-colorInherit');
      $(text).insertAfter(img);
    });
    $('.MuiButton-label').each(function(){
      var labelText = $(this).text();
      if(labelText.indexOf('ログインする') >= 0 ) {
        $(this).parents('.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12').addClass('og-wishlist-login');
      }
    });
    $('.wishlisthero-customer-view-listing').css('opacity', '1');
  },500);
});
